import { ZoomMakerFrame, ZoomMakerStatus } from '../types'
import Canvas from './canvas'
import Loader from './loader'

type Props = {
    className?: string
    frames: ZoomMakerFrame[]
    status?: ZoomMakerStatus
}

const ZoomMakerUploadPreview = ({ className, frames, status = ZoomMakerStatus.Idle }: Props) => {
    const isIdle = status === ZoomMakerStatus.Idle
    return (
        <div className={className}>
            <Canvas frames={frames} paused={!isIdle} />
            {!isIdle && <Loader status={status} />}
        </div>
    )
}

export default ZoomMakerUploadPreview
